import { connect } from 'react-redux'
import Login from './Login';
import { preLogin, login, reiniciarState, hidePopUp } from '../actions/Actions';
import { cerrarSesion } from '../../TopMenu/Actions';

const mapStateToProps = (state) => {
    return {
        loggedIn: state.sesion.loggedIn,
        loading: state.sesion.isFetching,
        user: state.sesion.user,
        error: state.sesion.error,
        errorMessage: state.sesion.errorMessage,
        passwordChange: state.sesion.passwordChange,
        passwordChangeUser: state.sesion.passwordChangeUser,
        executionContext: state.sesion.executionContext,
        configSession: state.sesion.configSession,
        adUserLogin: state.sesion.adUserLogin
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        preLoginFn: () => {
            dispatch(preLogin());
        },
        loginFn: (user, password) => {
            dispatch(login(user, password));
        },
        reiniciarState: () => {
            dispatch(reiniciarState());
        },
        cerrarSesion: () => {
            dispatch(cerrarSesion());
        },
        hidePopUp: () => {
            dispatch(hidePopUp());
        }
    }
}

const ConnectedLogin = connect(
    mapStateToProps,
    mapDispatchToProps
)(Login)

export default ConnectedLogin;



// WEBPACK FOOTER //
// ./Portico/App/Screens/Login/components/LoginContainer.js